module.exports = __webpack_public_path__ + "img/13.7672d6ea.jpg";